import { useTranslation } from "react-i18next";

interface Props {
  variant: "lemon" | "mandarin";
}

export const SubscriptionRestrictions = ({ variant }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="subscription-checkout__restrictions">
      <p
        dangerouslySetInnerHTML={{
          __html: t("subscription.toSwitchToPlan", {
            plan: variant === "lemon" ? "Free" : "Mini",
          }),
        }}
      />
      <ul>
        <li>{t("subscription.restrictions.users")},</li>
        {variant === "lemon" ? (
          <>
            <li>{t("subscription.restrictions.numberOfResources")},</li>
            <li>{t("subscription.restrictions.storage", { size: "5" })},</li>
            <li>{t("subscription.restrictions.privateResources")}.</li>
          </>
        ) : (
          <>
            <li>{t("subscription.restrictions.trackers")}</li>
            <li>{t("subscription.restrictions.storage", { size: "10" })}.</li>
          </>
        )}
      </ul>
      <p>
        {variant === "lemon"
          ? t("subscription.restrictions.finalMessageFree")
          : t("subscription.restrictions.finalMessageMini")}
      </p>
      <p
        dangerouslySetInnerHTML={{
          __html: t("subscription.restrictions.finalMessageWebgisBlocking"),
        }}
      />
    </div>
  );
};
